module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/shopping-bag.svg?8864e7d08ca115c14b7aa7be873c5e3b";